import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useCbomContext } from "../context/CbomContext";
import { fetchSensorAgentById } from "../services/apiServices";

const ViewAgent: React.FC = () => {
  const { selectedAgent, selectedAgentData } = useCbomContext();
  // const [formData, setFormData] = useState({
  //     sensor_agent_name: "",
  //     sensor_agent_type: "Host",
  //     sensor_agent_os_type: "Linux",
  //     sensor_agent_cpu_type: "",
  //     sensor_agent_state: "Inactive",
  //     sensor_agent_version: ""
  //   });
  // useEffect(() => {
  //       fetchSensorAgentById(selectedAgent, setFormData);
  // }, []);
  return (
    <div className="flex flex-col w-full overflow-auto">
      <div className="w-full bg-custom-blue8 rounded-[10px]">
        <form>
          <div className="bg-custom-lightbg rounded-[10px] mx-5">
            {/* Row 1 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Name
                </label>
                <input
                  type="text"
                  disabled
                  value={selectedAgentData?.sensor_agent_name}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Type
                </label>
                <div className="relative flex items-center">
                  <input
                  type="text"
                  disabled
                  value={selectedAgentData?.sensor_agent_type}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent OS type
                </label>
                <div className="relative flex items-center">
                  <input
                  type="text"
                  disabled
                  value={selectedAgentData?.sensor_agent_os_type}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
                </div>
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent CPU type
                </label>
                <div className="relative flex items-center">
                  <input
                  type="text"
                  disabled
                  value={selectedAgentData?.sensor_agent_cpu_type}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent state
                </label>
                <input
                  type="text"
                  disabled
                  value={selectedAgentData?.sensor_agent_state}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew"
                />
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Version
                </label>
                <input
                  type="text"
                  value={selectedAgentData?.sensor_agent_version}
                  disabled
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          {/* <div className="text-center space-x-20 pt-5 pb-8">
            <button type="button" className="px-6 h-[40px] bg-custom-blue5 text-white rounded-lg"
              onClick={()=> setShowAgentUpload(true)}>
              Upload
            </button>
            <button type="button" className="px-6 h-[40px] bg-custom-blue4 text-white rounded-lg">
              Activate
            </button>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default ViewAgent;
